import React from "react"
import { Link } from "react-router-dom"
import { Input, Button, Table, Space } from 'antd'
import { SearchOutlined, RedoOutlined } from '@ant-design/icons'
import { axiosTable } from '../../tool/axios'
import BreadCrumb from '../../component/BreadCrumb'

const { Column } = Table

interface State {
    data: object[],
    loading: boolean,
    pagination: {
        current: number,
        pageSize: number,
        total: number
    },
    fetchOtherParams: {
        brand_name: string | null,
        store_name: string | null,
        item_type: string | null,
        item_name: string | null,
        item_status: string | null
    },
    formParams: {
        item_type: string | null
    },
    offShelfVisible: boolean,
    addVisible: false
}

export default class BrandList extends React.Component {
    state: State = {
        data: [],
        loading: false,
        pagination: {
            current: 1,
            pageSize: 10,
            total: 0
        },
        fetchOtherParams: {
            brand_name: null,
            item_type: null,
            item_name: null,
            store_name: null,
            item_status: null
        },
        formParams: {
            item_type: null
        },
        offShelfVisible: false,
        addVisible: false
    }

    componentDidMount() {
        const { pagination, fetchOtherParams } = this.state
        this.fetch({ pagination, fetchOtherParams })
    }

    offShelf() {
        this.setState({ offShelfVisible: true })
    }

    handleInputChange(e: any) {
        let { fetchOtherParams } = this.state
        fetchOtherParams.brand_name = e.target.value

        this.setState({ fetchOtherParams })
    }

    handleTableChange = (antPagination: any) => {
        const { fetchOtherParams, pagination } = this.state
        pagination.current = antPagination.current
        pagination.pageSize = antPagination.pageSize

        this.fetch({
            pagination,
            fetchOtherParams
        })
    }

    selectState(type: string) {
        let { pagination, fetchOtherParams } = this.state;

        if (type != 'current') {
            pagination.current = 1;
        }

        this.fetch({
            pagination,
            fetchOtherParams
        })
    }

    fetch({ pagination, fetchOtherParams }: { pagination: Object, fetchOtherParams: object }) {
        const iPagination: any = { ...pagination }
        iPagination.page_num = iPagination.current
        iPagination.page_size = iPagination.pageSize

        delete iPagination.current
        delete iPagination.pageSize
        delete iPagination.total

        axiosTable.get('/manage_center/brand/page_list', {
            params: {
                ...iPagination,
                ...fetchOtherParams
            }

        }).then((response: any) => {
            const { pagination } = this.state
            pagination.total = response.total
            pagination.pageSize = response.size
            pagination.current = response.current

            this.setState({
                pagination,
                data: response.records
            })
        })
    }

    resetForm() {
        let { fetchOtherParams } = this.state
        fetchOtherParams.brand_name = null

        this.setState({ fetchOtherParams })
        this.selectState('')
    }

    render() {
        let { brand_name } = this.state.fetchOtherParams

        return (<div className="common-page">
            {/* 管理中心 -> 品牌及门店 -> 品牌管理 */}
            <BreadCrumb position={['管理中心', '品牌管理']} />

            <div className="common-top-form">
                <Space direction="horizontal" wrap>
                    <Input style={{ marginRight: 8, marginBottom: 12, width: '150px' }} placeholder="品牌名称" value={brand_name === null ? '' : brand_name} onChange={this.handleInputChange.bind(this)} />

                    <Button style={{ marginRight: 5, marginBottom: 12 }} className="search-btn" icon={<SearchOutlined />} onClick={this.selectState.bind(this, '')} >查询</Button>
                    <Button style={{ marginRight: 5, marginBottom: 12 }} onClick={this.resetForm.bind(this)} icon={<RedoOutlined />}>重置</Button>
                    <Button style={{ marginRight: 5, marginBottom: 12 }} type="primary"><Link to={"/brand_add"}>添加</Link></Button>
                </Space>
            </div>

            <div className="common-main">
                <Table dataSource={this.state.data} scroll={{ x: 'max-content' }} bordered={true} pagination={this.state.pagination} rowKey="id" onChange={this.handleTableChange.bind(this)}>
                    <Column title="品牌名称" dataIndex="brand_name" key="brand_name" />
                    <Column title="客服电话" dataIndex="cs_phone" key="cs_phone" />
                    <Column title="创建时间" dataIndex="create_date" key="create_date" />

                    <Column
                        title="操作"
                        key="action"
                        render={(text, record: any) => (
                            <Space size="middle">
                                <Link to={"/brand_edit/" + record.id}><Button type="primary">编辑</Button></Link>
                            </Space>
                        )}
                    />
                </Table>
            </div>
        </div>)
    }
}